import { datacenters } from '@getaccept/lib-shared/src/datacenter/constants/datacenters';
import { DatacenterId } from '@getaccept/lib-shared/src/datacenter/enums/datacenter-id';
import type { Datacenter } from '@getaccept/lib-shared/src/datacenter/types/datacenter';

export function getDatacenterFromCountry(countryKey: string): Datacenter {
  switch (countryKey) {
    case 'AD':
    case 'AL':
    case 'AM':
    case 'AT':
    case 'AZ':
    case 'BA':
    case 'BE':
    case 'BG':
    case 'BY':
    case 'CH':
    case 'CY':
    case 'CZ':
    case 'DE':
    case 'DK':
    case 'EE':
    case 'ES':
    case 'FI':
    case 'FR':
    case 'GE':
    case 'GL':
    case 'GR':
    case 'HR':
    case 'HU':
    case 'IS':
    case 'IT':
    case 'KZ':
    case 'LI':
    case 'LT':
    case 'LU':
    case 'LV':
    case 'MC':
    case 'MD':
    case 'ME':
    case 'MK':
    case 'MT':
    case 'NL':
    case 'NO':
    case 'PL':
    case 'PT':
    case 'RO':
    case 'RS':
    case 'RU':
    case 'SE':
    case 'SI':
    case 'SK':
    case 'SM':
    case 'TR':
    case 'UA':
    case 'VA':
    case 'XK':
      return getDatacenterFromId(DatacenterId.EUFrankfurt);
    case 'IE':
    case 'GB':
    case 'IN':
      return getDatacenterFromId(DatacenterId.EUIreland);
    case 'BR':
      return getDatacenterFromId(DatacenterId.SASaoPaulo);
    case 'HK':
    case 'SG':
    case 'CN':
    case 'TH':
      return getDatacenterFromId(DatacenterId.APACSingapore);
    case 'AU':
      return getDatacenterFromId(DatacenterId.APACSydney);
    default:
      return getDatacenterFromId(DatacenterId.USOregon);
  }
}

export function getDatacenterFromId(id: DatacenterId): Datacenter {
  const datacenter = datacenters.find((datacenter: Datacenter) => datacenter.id === id);
  if (!datacenter) {
    throw new Error(`Datacenter with id ${id} not found`);
  }
  return datacenter;
}
